import { isNotNil } from '@flowio/is';
export default function isUnknownObject(value) {
  return isNotNil(value) && typeof value === 'object';
}
//# sourceMappingURL=isUnknownObject.js.map